import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { MapChartCard } from "@/partner/shared/components/MapChartCard";
import { useAnalyticsUsersByCountryQuery } from "@/partner/entities/analytics";

export const AnalyticsUsersByCountryMap: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  const { data, loading, error } = useAnalyticsUsersByCountryQuery({
    variables: { filter: filter as never, limit: 300 },
  });

  return (
    <MapChartCard
      title={t("analytics.users.mapByCountry")}
      data={data?.analyticsUsers.usersByCountry}
      loading={loading}
      error={error}
      field="users"
    />
  );
};
